import { render, staticRenderFns } from "./testingConfirmation.vue?vue&type=template&id=99a061ee&"
import script from "./testingConfirmation.vue?vue&type=script&lang=js&"
export * from "./testingConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports